import React, { forwardRef } from "react";
import { Button, Section, Text } from "@/components";
import "./PricingSection.scss";

export const PricingSection = forwardRef<HTMLElement, {}>((props, ref) => {
  const handleScheduleCall = () => {
    window.open("https://calendly.com/dustinrbyington/30min", "_blank");
  };

  return (
    <Section
      ref={ref}
      id="pricing-section"
      className="w-full mx-0 px-4 md:px-0 md:py-0 mt-[20px] md:mt-0 rounded-t-[20px] md:rounded-t-[60px] bg-white"
    >
      <div className="w-full lg:w-[856px] mx-auto py-12 md:py-[96px]">
        <div className="flex flex-col items-center gap-y-6 md:gap-y-8 text-center">
          <div className="hidden md:flex gap-2">
            <Text.Heading size="lg" className="font-semibold text-black text-center md:leading-[78px]">
              Pricing
            </Text.Heading>
            <Text.Heading size="lg" className="font-semibold text-black text-center md:leading-[78px] pricing-title">
              On Request
            </Text.Heading>
          </div>

          <div className="flex md:hidden gap-1.5">
            <Text.Heading size="lg" className="font-400 font-calSans text-black text-center pricing-section-title">
              Pricing
            </Text.Heading>
            <Text.Heading size="lg" className="font-400 font-calSans text-black text-center pricing-section-title pricing-title">
              On Request
            </Text.Heading>
          </div>

          <Text.Description
            size="md"
            className="max-w-[720px] text-black font-400"
          >
            Every deployment is bespoke. Tell us about your pipeline and we'll tailor access, onboarding, and pricing.
          </Text.Description>

          <div className="flex justify-center w-full mt-4">
            <Button
              className="w-full max-w-[420px] md:max-w-[480px] h-[60px] !border-none"
              onClick={handleScheduleCall}
            >
              <span className="font-semibold text-base md:text-[18px] md:leading-[26px] whitespace-nowrap">
                Request pricing & schedule a call
              </span>
            </Button>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-center gap-4 text-white sm:mt-12 sm:flex-row sm:items-center sm:gap-12">
          <div className="text-black text-[18px] leading-[20px] md:text-[28px] md:leading-[20px] font-inter">
            Our Partner
          </div>
          <div className="flex items-center gap-4">
            <a href="https://www.lpshares.com" target="_blank">
              <img
                src="/images/lpshares/lp-logo.png"
                alt="LP Shares"
                className="w-[251px] h-auto object-contain"
              />
            </a>
          </div>
        </div>
      </div>
    </Section>
  );
});
